/* Copyright (c) Trimble Inc. All rights reserved. */

import { withMVC } from '@tcp-base/design-system';
import useSessionExpiryDialogController from './SessionExpiryDialog.controller';
import { type SessionExpiryDialogViewerProps } from './SessionExpiryDialog.model';
import SessionExpiryDialogViewer from './SessionExpiryDialog.viewer';

/**
 * SessionExpiryDialog
 *
 * Self-contained component that monitors token expiry and displays a warning dialog
 * with a countdown timer. Mounted once inside AuthProvider.
 *
 * - Shows 2 minutes before token expiry (SESSION_EXPIRY_WARN_BEFORE_SECONDS).
 * - Countdown runs for 60 seconds (SESSION_EXPIRY_COUNTDOWN_SECONDS).
 * - "Stay Signed In" triggers re-authentication and returns user to the same page.
 * - "Logout" / countdown=0 clears session data and redirects to the login page.
 */
export const SessionExpiryDialog = withMVC<Record<string, never>, SessionExpiryDialogViewerProps>({
  useController: useSessionExpiryDialogController,
  Viewer: SessionExpiryDialogViewer,
});

export default SessionExpiryDialog;
